var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgO4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 28,
    viewBox: "0 0 65 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2348_1566)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 28,
    rx: 10,
    fill: "#BAEAC8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 23V7C8 6.46957 8.21071 5.96086 8.58579 5.58579C8.96086 5.21071 9.46957 5 10 5H20C20.5304 5 21.0391 5.21071 21.4142 5.58579C21.7893 5.96086 22 6.46957 22 7V23L19 21L17 23L15 21L13 23L11 21L8 23Z",
    stroke: "#2A2A2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7502 8.2C15.7502 7.78578 15.4145 7.45 15.0002 7.45C14.586 7.45 14.2502 7.78578 14.2502 8.2V9.08215C13.8153 9.13206 13.3638 9.24861 12.9763 9.48992C12.4854 9.79568 12.1333 10.2828 12.0544 10.947C11.9951 11.4462 12.0482 11.9044 12.2355 12.3086C12.4236 12.7147 12.7193 13.0059 13.0446 13.2154C13.6428 13.6006 14.4278 13.7546 15.0237 13.8715L15.0507 13.8768L15.1019 13.8868C15.4077 13.9468 15.6768 13.9996 15.9206 14.0654C16.1793 14.1354 16.3585 14.2074 16.4776 14.2824C16.5857 14.3505 16.6173 14.4033 16.6318 14.4419C16.649 14.4877 16.6771 14.6098 16.613 14.8717C16.5811 15.0021 16.4942 15.1259 16.2565 15.2385C16.0021 15.3588 15.6322 15.4333 15.1834 15.4475C14.2676 15.4765 13.3191 15.2502 12.9499 15.0557C12.5835 14.8626 12.1299 15.0031 11.9367 15.3695C11.7436 15.736 11.8841 16.1896 12.2506 16.3827C12.7162 16.6281 13.4639 16.8258 14.2502 16.9083V17.8C14.2502 18.2142 14.586 18.55 15.0002 18.55C15.4145 18.55 15.7502 18.2142 15.7502 17.8V16.9074C16.1465 16.8584 16.5432 16.7623 16.8982 16.5942C17.4261 16.3444 17.9029 15.9106 18.07 15.2285C18.1825 14.7689 18.1895 14.3227 18.0359 13.9141C17.8796 13.4984 17.5908 13.2109 17.277 13.0132C16.9741 12.8224 16.6299 12.7033 16.3119 12.6174C16.0149 12.5371 15.6963 12.4747 15.4052 12.4177L15.3396 12.4049C14.668 12.273 14.1763 12.16 13.8566 11.9542C13.7183 11.8652 13.6416 11.7752 13.5965 11.678C13.5506 11.5789 13.5098 11.4116 13.5439 11.1239C13.5656 10.9417 13.6389 10.8444 13.7694 10.7631C13.9327 10.6614 14.2022 10.5826 14.5829 10.558C15.3422 10.509 16.2607 10.6922 16.8371 10.886C17.2297 11.0181 17.6551 10.8069 17.7871 10.4143C17.9191 10.0217 17.7079 9.59635 17.3153 9.4643C16.9033 9.32572 16.3455 9.18789 15.7502 9.11133V8.2Z",
    fill: "#2A2A2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.732 16.296V14.976L35.656 9.36H37.612V14.832H38.668V16.296H37.612V18H35.932V16.296H31.732ZM36.04 11.16L33.58 14.832H36.04V11.16ZM45.6176 10.704H41.7296V12.756C41.8976 12.548 42.1376 12.38 42.4496 12.252C42.7616 12.116 43.0936 12.048 43.4456 12.048C44.0856 12.048 44.6096 12.188 45.0176 12.468C45.4256 12.748 45.7216 13.108 45.9056 13.548C46.0896 13.98 46.1816 14.444 46.1816 14.94C46.1816 15.86 45.9176 16.6 45.3896 17.16C44.8696 17.72 44.1256 18 43.1576 18C42.2456 18 41.5176 17.772 40.9736 17.316C40.4296 16.86 40.1216 16.264 40.0496 15.528H41.6816C41.7536 15.848 41.9136 16.104 42.1616 16.296C42.4176 16.488 42.7416 16.584 43.1336 16.584C43.6056 16.584 43.9616 16.436 44.2016 16.14C44.4416 15.844 44.5616 15.452 44.5616 14.964C44.5616 14.468 44.4376 14.092 44.1896 13.836C43.9496 13.572 43.5936 13.44 43.1216 13.44C42.7856 13.44 42.5056 13.524 42.2816 13.692C42.0576 13.86 41.8976 14.084 41.8016 14.364H40.1936V9.228H45.6176V10.704ZM51.5882 18L49.3322 15.168V18H47.6522V9.12H49.3322V14.172L51.5642 11.352H53.7482L50.8202 14.688L53.7722 18H51.5882Z",
    fill: "#2A2A2B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2348_1566",
    x: -200,
    y: -200,
    width: 465,
    height: 428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2348_1566"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2348_1566",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO4);
export default __webpack_public_path__ + "static/media/o4.b369efc98ba5654ddab10d88a31fd8b0.svg";
export { ForwardRef as ReactComponent };